module.exports = __webpack_public_path__ + "img/szxx.5f8155df.png";